import React, { createContext, useContext, useState } from "react";

const InvoiceContext = createContext();

export const InvoiceProvider = ({ children }) => {
  const [invoiceId,setInvoiceId]=useState()
  const[activeTabLabel,setActiveTabLabel]=useState()

  return (
    <InvoiceContext.Provider value={{ invoiceId, setInvoiceId,activeTabLabel,setActiveTabLabel }}>
      {children}
    </InvoiceContext.Provider>
  );
};

export const useInvoice= () => useContext(InvoiceContext);
